export const DEFAULT_MATERIALS = [
  { id: "mulch", label: "Mulch", unit: "per yard", cost: 0, markup: 2.5 },
  { id: "pine_straw", label: "Pine straw", unit: "per bale", cost: 0, markup: 2.5 },
  { id: "sod", label: "Sod", unit: "per pallet", cost: 0, markup: 2.0 },
  { id: "fertilizer", label: "Fertilizer", unit: "per bag", cost: 0, markup: 2.5 },
  { id: "soil", label: "Soil/compost", unit: "per yard", cost: 0, markup: 2.0 },
  { id: "seed", label: "Grass seed", unit: "per bag", cost: 0, markup: 2.5 },
  { id: "gravel", label: "Gravel/stone", unit: "per ton", cost: 0, markup: 2.0 },
  { id: "edging", label: "Landscape edging", unit: "per 20ft roll", cost: 0, markup: 2.0 },
  { id: "annuals", label: "Annuals/plants", unit: "per flat", cost: 0, markup: 2.5 },
  { id: "pavers", label: "Pavers", unit: "per sq ft", cost: 0, markup: 2.0 },
];
